export class Language {
    display = 'English'; // defaults
    locale = 'en-US'; // defaults
    drupalCode = 'en';

    constructor(obj?: Partial<Language>) {
        Object.assign(this, obj);
    }
}

export class FullSiteLanguage {
    localeCode: string;
    translationCode: string;
    localName: string;
    translationKey: string;
}

export type ProductToLanguageListMapServerEntry = {
    // drupalCode: "da"
    drupalCode: string;
    // languageLocaleCode: "da-DK"
    languageLocaleCode: string;
    // localizedName: "Danish"
    localizedName: string;
    // name: "Danish"
    name: string;
    // productName: "Guides"
    productName: string;
    // availability: true | false
    isAvailableForPI2: boolean;
};

export type ProductToLanguageListMap = {
    FullSite: ProductToLanguageListMapServerEntry[];
    [key: string]: ProductToLanguageListMapServerEntry[];
};

/**
 * Represents a supported site language with its locale code and display name.
 */
export type SupportedSiteLanguage = {
    /**
     * The locale code of the language, e.g., 'en-US'.
     */
    localeCode: string;

    /**
     * The display name of the language, e.g., 'English'.
     * Note: This is the already translated display name.
     */
    displayName: string;
};
